export default function TypeBennesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('type.bennes');
    $translatePartialLoaderProvider.addPart('unites');
}

TypeBennesConfiguration.$inject = ['$translatePartialLoaderProvider'];
